import { render, staticRenderFns } from "./PostbackSecurity.vue?vue&type=template&id=7ce4d149"
import script from "./PostbackSecurity.vue?vue&type=script&lang=js"
export * from "./PostbackSecurity.vue?vue&type=script&lang=js"
import style0 from "./PostbackSecurity.vue?vue&type=style&index=0&id=7ce4d149&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports